import React, { Component } from "react";
import axios from "axios";
import { createStyles, withStyles } from "@material-ui/styles";
import CircularProgress from "@material-ui/core/CircularProgress";
import Snackbar from "@material-ui/core/Snackbar";

import IconButton from "@material-ui/core/IconButton";
import { FormLabel, createMuiTheme } from "@material-ui/core";

import CloseIcon from "@material-ui/icons/Close";
import ThemeProvider from "@material-ui/styles/ThemeProvider";
import { Errors } from "../constants/errors.constants";

const alignSelfMapper = {
  "0": "flex-start",
  "1": "center",
  "2": "flex-end",
};

export const InputType = {
  CONTACT_NAME: { name: "Nombre", id: "name" },
  CONTACT_EMAIL: { name: "Email", id: "email" },
  CONTACT_PHONE: { name: "Teléfono", id: "phone" },
  COMPANY_NAME: { name: "Nombre de Empresa", id: "enterprise" },
  NUMBER: { name: "Número", id: "number" },
  TEXT: { name: "Texto", id: "text" },
  LONG_TEXT: { name: "Texto Extenso", id: "textarea" }
}

const Action = {
  MESSAGE: "message",
  REDIRECT: "redirect"
};

const styles = createStyles({
  loadingContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
  errorContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    color: "red",
    textAlign: "center",
  },
  title: {
    marginBottom: "20px !important",
    textAlign: "center !important",
    fontWeight: "200 !important",
  },
  input: {
    backgroundColor: "#f7f7f7 !important",
    marginBottom: "10px !important",
    padding: "10px 15px !important",
    margin: "5px 0 !important",
    display: "inline-block !important",
    border: "1px solid #e6e6e6 !important",
    borderRadius: "25px !important",
    fontSize: "14px !important",
    "&:focus-visible": {
      outline: "none",
    },
  },
  textarea: {
    padding: "10px 10px !important",
    borderRadius: "15px !important",
    resize: "vertical !important",
  },
  error: {
    borderColor: "#FF5454 !important",
  },
  submit: {
    color: "white",
    margin: "8px 0 !important",
    border: "none !important",
    padding: "10px 20px !important",
    borderRadius: "20px !important",
    "&:hover": {
      opacity: "0.6 !important",
    },
  },
});

class FormWidget extends Component {
  state = {
    loadingConfig: true,
    showSuccessMessage: false,
    sendingEmail: false,
    submitted: false,
    submitButtonSize: 100,
    submitButtonFontSize: 15,
    inputs: [],
    errors: {},
    error: null,
  };

  componentWillMount() {
    (async () => {
      try {
        const urlParams = new URLSearchParams(window.location.search);
        let companyId =
          this.props.companyId ||
          window.wembiiFormCompanyId ||
          urlParams.get("companyId");
        let formId =
         this.props.formId || window.formId || urlParams.get("formId");

        companyId = atob(companyId);
        formId = atob(formId);

        this.setState({ companyId, formId });

        const { data } = await axios.get(`${process.env.REACT_APP_SERVER_URL}/api/public/form/web/config`, {
          params: { companyId, formId },
        });

        if (!data.payload.form || !data.payload.inputs) {
          return this.setState({
            loadingConfig: false,
            error: "Formulario no encontrado",
          });
        }

        const theme = createMuiTheme({ });

        const inputs = this.mapDataToState(data.payload.inputs)
        const { form } = data.payload;
        const {
          title,
          titleSize,
          titleColor,
          buttonColor,
          buttonTextColor,
          buttonPosition,
          buttonText,
          action = "message",
          successfulMessage = "Gracias por enviar el formulario",
          buttonTextSize = 15,
          buttonSize = 200,
          redirectUrl,
          isActive
        } = form;
        this.setState({
          theme,
          title,
          titleSize,
          titleColor,
          loadingConfig: false,
          buttonColor,
          buttonText,
          buttonTextColor,
          buttonPosition,
          successMessage: successfulMessage,
          submitButtonSize: buttonSize,
          submitButtonFontSize: buttonTextSize,
          redirectUrl,
          isActive,
          action,
          inputs,
        });
      } catch (err) {
        if (err.request.status === 403) {
          this.state.error = JSON.parse(err.request.response).code || 0;
        }

        console.error(err);
        this.setState({
          loadingConfig: false,
        });
      }
    })();
  }

  mapDataToState = (inputs) => {
    return inputs.map((input) => {
      return input;
    });
  };

  validateEmail = (email) => {
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
      return true;
    }

    return false;
  };

  hasInputError = (input, value) => {
    const inputValue = value || this.state[input.id];

    if (input.required && !inputValue) return true;
    if (this.hasInputTypeError(input, inputValue)) return true;
    return false;
  };

  hasInputTypeError = (input, value) => {
    const inputValue = value || this.state[input.id];
    switch (input.type) {
      case "email": {
        return !this.validateEmail(inputValue);
      }
      default:
        return false;
    }
  };

  updateInput = (input) => (event) => {
    const value = event.target.value;
    let errors = {
      ...this.state.errors,
    };
    if (this.state.errors[input.id]) {
      const hasError = this.hasInputError(input, value);
      errors[input.id] = hasError;
    }

    this.setState({
      [input.id]: value,
      errors,
    });
  };

  sendMessage = (e) => {
    e.stopPropagation();

    this.setState(
      {
        sendingEmail: true,
        errors: {},
        submitted: true,
      },
      async () => {
        const { companyId, inputs, formId, redirectUrl, action } = this.state;
        let showSuccessMessage = false;

        const { form, errors } = inputs.reduce(
          (obj, input) => {
            const value = this.state[input.id];
            let prop = input.id;

            obj.form[prop] = {
              ...input,
              value: value,
            };
            obj.errors[prop] = this.hasInputError(input, value);

            return obj;
          },
          { errors: {}, form: {} }
        );

        const onlyErrors = Object.keys(errors).filter((prop) => errors[prop]);

        if (onlyErrors.length > 0) {
          return this.setState({
            missingFieldsMessage: "Complete los campos requeridos",
            sendingEmail: false,
            errors,
          });
        }

        try {
          await axios.post(`${process.env.REACT_APP_SERVER_URL}/api/public/form/web/send?companyId=${companyId}`, {
            companyId,
            formId,
            form,
            reference: window.location.href,
          });

          const cleanState = Object.keys(form).reduce((state, key) => {
            state[key] = "";
            return state;
          }, {});

          if (action === Action.MESSAGE) {
            showSuccessMessage = true;
          } else {
            window.location.href = redirectUrl;
          }

          this.setState({
            showSuccessMessage,
            sendingEmail: false,
            ...cleanState,
          });
        } catch (err) {
          if (err.request.status === 403) {
            this.state.error = JSON.parse(err.request.response).code || 0;
          }
          this.setState({
            showErrorMessage: true,
            sendingEmail: false,
          });
        }
      }
    );
  };

  renderSuccessMessage = () => {
    const { successMessage, showSuccessMessage } = this.state;
    const handleClose = () => {
      this.setState({
        showSuccessMessage: false,
      });
    };

    return (
      <Snackbar
        anchorOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        open={showSuccessMessage}
        autoHideDuration={3000}
        onClose={handleClose}
        message={successMessage}
        action={
          <React.Fragment>
            <IconButton
              size="small"
              aria-label="close"
              color="inherit"
              onClick={handleClose}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </React.Fragment>
        }
      />
    );
  };

  renderErrorMessage = () => {
    const { errorMessage, showErrorMessage } = this.state;
    const handleClose = () => {
      this.setState({
        showErrorMessage: false,
      });
    };

    return (
      <Snackbar
        anchorOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        open={showErrorMessage}
        autoHideDuration={3000}
        onClose={handleClose}
        message={errorMessage}
        action={
          <React.Fragment>
            <IconButton
              size="small"
              aria-label="close"
              color="inherit"
              onClick={handleClose}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </React.Fragment>
        }
      />
    );
  };

  getTypeInput = (type) => {
    switch (type) {
      case InputType.CONTACT_NAME.id:
        return "text";
      case InputType.TEXT.id:
        return "text";
      case InputType.COMPANY_NAME.id:
        return "text";
      case InputType.CONTACT_EMAIL.id:
        return "email";
      case InputType.NUMBER.id:
        return "number";
      case InputType.CONTACT_PHONE.id:
        return "number";
      default:
        return "text";
    }
  };

  getTypeStyle = (id, type) => {
    const { classes } = this.props;
    const { submitted, errors } = this.state;
    let defaultClass = classes.input;

    if (submitted && errors[id]) {
      defaultClass = `${defaultClass} ${classes.error}`;
    }

    switch (type) {
      case InputType.LONG_TEXT.id:
        return `${defaultClass} ${classes.textarea}`;
      default:
        return defaultClass;
    }
  };

  renderInputs() {
    const { inputs } = this.state;
    
    return inputs.map((input, i) => {
      return input.type !== InputType.LONG_TEXT.id ? (
        <input
          key={i}
          type={this.getTypeInput(input.type)}
          placeholder={input.required ? `${input.placeholder}*` : input.placeholder}
          className={this.getTypeStyle(input.id, input.type)}
          value={this.state[input.id]}
          onChange={this.updateInput(input)}
        />
      ) : (
        <textarea
          key={i}
          rows={input.type === "textarea" ? 4 : 1}
          placeholder={input.required ? `${input.placeholder}*` : input.placeholder}
          className={this.getTypeStyle(input.id, input.type)}
          value={this.state[input.id]}
          onChange={this.updateInput(input)}
        />
      );
    });
  }

  render() {
    const { classes } = this.props;
    const {
      theme,
      title,
      buttonColor,
      titleSize,
      titleColor,
      submitButtonSize,
      buttonTextColor,
      buttonText,
      buttonPosition,
      submitButtonFontSize,
      loadingConfig,
      sendingEmail,
      error,
      isActive
    } = this.state;

    if (loadingConfig) {
      return (
        <div className={classes.loadingContainer}>
          <CircularProgress color={buttonColor} />
        </div>
      );
    }

    if (error === Errors.CompanyDisabled) {
      return null;
    }

    if (error === Errors.InvalidPlan) {
      return (
        <div className={classes.errorContainer}>
          <h2>El formulario no pudo ser cargado por falta de pago, por favor contactar al equipo comercial de Wembii</h2>
        </div>
      );
    }
  
    return (
      <ThemeProvider theme={theme}>
        {isActive &&
          <form
            style={{
              display: "flex",
              flex: 1,
              flexDirection: "column",
              margin: 20,
            }}
            noValidate
            autoComplete="off"
          >
            {title && (
              <FormLabel
                className={classes.title}
                style={{
                  fontSize: titleSize,
                  color: titleColor,
                }}
              >
                {title}
              </FormLabel>
            )}

            {this.renderInputs()}

            <button
              type="button"
              disabled={sendingEmail}
              onClick={this.sendMessage}
              className={classes.submit}
              style={{
                backgroundColor: buttonColor,
                color: buttonTextColor,
                width: submitButtonSize,
                fontSize: submitButtonFontSize,
                alignSelf: alignSelfMapper[buttonPosition],
              }}
              required
            >
              {buttonText}
            </button>

            {this.renderSuccessMessage()}
            {this.renderErrorMessage()}
          </form>
        }
      </ThemeProvider>
    );
  }
}

FormWidget.propTypes = {};

export default withStyles(styles)(FormWidget);
